import { render, staticRenderFns } from "./AppAnnotationReportDetails.vue?vue&type=template&id=3a8bcade&scoped=true"
import script from "./AppAnnotationReportDetails.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationReportDetails.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationReportDetails.vue?vue&type=style&index=0&id=3a8bcade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8bcade",
  null
  
)

export default component.exports